import { CountryCode, isValidPhoneNumber } from 'libphonenumber-js'

export function numericOnlyInput (event: KeyboardEvent) {
   if (['e', 'E', '-', '+'].includes(event.key)) {
      event.preventDefault();
   }
}

export function checkPhoneNumberValidity(phoneNumber: string, country: CountryCode) {
   return isValidPhoneNumber(phoneNumber, country);
}